import Breakpoint from './Breakpoint.styled'

export default Breakpoint
